import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingNabidkaDetail = lazy(() =>
  import('@/modules/leasing/LeasingNabidkaDetail').then((m) => ({
    default: m.LeasingNabidkaDetail,
  })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/nabidky/$id',
  component: () => (
    <Suspense fallback={null}>
      <LeasingNabidkaDetail />
    </Suspense>
  ),
});
